/**
 * Portal section viewed event – tracks when users view different sections of the portal.
 * Limit 1 view event per section per page view
 */

import { z } from 'zod';

import { defineEvent } from '../event-factory';
import { buildTrackingKey } from '../utils';

export default defineEvent({
  eventName: 'healthgrades.PortalSectionViewed.v1',

  // What data this event needs (see schema link for full details)
  // https://app.make.rvohealth.com/schemas/sch_2xgmRg27J8tdfzKNofm44LrSrrw
  cohesionSchema: {
    section: z.string(),
    subSection: z.string().optional(),
    authenticationLevel: z.string().optional(),
    providerKeys: z.array(z.string()).optional(),
    pendingTasks: z.array(z.string()).optional(),
    providerList: z.array(z.string()).optional(),
    viewCorrelationID: z.uuid().optional(),
  },

  tealiumMethodType: 'link',

  // Deduplication: One event per unique section+subSection combo per page view
  deduplication: {
    scope: 'page',
    keyBuilder: (params) =>
      buildTrackingKey({
        section: params.section,
        subSection: params.subSection,
      }),
  },
});
